module.exports = __webpack_public_path__ + "static/img/1-1.8c397d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/1-1.png
// module id = IV4f
// module chunks = 0